type Feature = {
  key: "co2" | "esg" | "esrs" | "sfdr" | "co2-free";
  title: string;
  dataCollection: string;
  hasReportGeneration: boolean;
  hasDashboards: boolean;
  hasDecarbonisationRecommendations: boolean;
  hasAudit: boolean;
  hasEUTaxonomy: boolean;
  hasDoubleMateriality: boolean;
};

export const FEATURES_TABLE: Feature[] = [
  {
    key: "co2-free",
    title: "CO2 - Free",
    dataCollection: "CO2 scope 1, 2",
    hasReportGeneration: true,
    hasDashboards: true,
    hasDecarbonisationRecommendations: true,
    hasAudit: false,
    hasEUTaxonomy: false,
    hasDoubleMateriality: false,
  },
  {
    key: "co2",
    title: "CO2",
    dataCollection: "CO2 scope 1, 2, 3",
    hasReportGeneration: true,
    hasDashboards: true,
    hasDecarbonisationRecommendations: true,
    hasAudit: true,
    hasEUTaxonomy: false,
    hasDoubleMateriality: false,
  },
  {
    key: "esrs",
    title: "CSRD",
    dataCollection: "ESRS & CO2",
    hasReportGeneration: true,
    hasDashboards: true,
    hasDecarbonisationRecommendations: true,
    hasAudit: true,
    hasEUTaxonomy: true,
    hasDoubleMateriality: true,
  },
  {
    key: "esg",
    title: "ESG",
    dataCollection: "ESG / GRI / OJK",
    hasReportGeneration: true,
    hasDashboards: true,
    hasDecarbonisationRecommendations: true,
    hasAudit: false,
    hasEUTaxonomy: false,
    hasDoubleMateriality: false,
  },
  {
    key: "sfdr",
    title: "SFDR",
    dataCollection: "SFDR",
    hasReportGeneration: true,
    hasDashboards: true,
    hasDecarbonisationRecommendations: true,
    hasAudit: false,
    hasEUTaxonomy: false,
    hasDoubleMateriality: false,
  },
] as const;
